import { render, staticRenderFns } from "./IrisLottieAnimation.vue?vue&type=template&id=72d5e5da&"
import script from "./IrisLottieAnimation.vue?vue&type=script&lang=ts&"
export * from "./IrisLottieAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./IrisLottieAnimation.vue?vue&type=style&index=0&id=72d5e5da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports